import { render, staticRenderFns } from "./KitBudgetTab.vue?vue&type=template&id=51122435&scoped=true&"
import script from "./KitBudgetTab.vue?vue&type=script&lang=js&"
export * from "./KitBudgetTab.vue?vue&type=script&lang=js&"
import style0 from "./KitBudgetTab.vue?vue&type=style&index=0&id=51122435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51122435",
  null
  
)

export default component.exports